import { IS_MOBILE } from "const/common";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";

const Dropdown = ({
  selectedOption,
  placeholder,
  options,
  onSelect,
  name,
  control,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const handleOptionClick = (option) => {
    setIsOpen(false);
    onSelect(option);
  };
  useEffect(() => {
    setIsMobile(IS_MOBILE(600));
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: true }}
      render={({ field: { value, onChange } }) => (
        <>
          {isMobile ? (
            <div className="relative inline-block w-full cursor-pointe rounded-lg">
              <p
                onClick={toggleDropdown}
                className="w-full bg-white text-[#999999] px-6 py-4 rounded-lg focus:outline-none flex justify-between items-center"
              >
                <span className="text-ellipsis line-clamp-1 w-4/5">
                  {value || placeholder}
                </span>
                <svg
                  className={`fill-[#999999] h-4 w-4 transform ${
                    isOpen ? "rotate-180" : "rotate-0"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </p>
              <ul
                className={`${
                  isOpen ? "block" : "hidden"
                } z-10 mt-2 w-full bg-white rounded-lg p-5`}
              >
                {options.map((option, index) => (
                  <>
                    <li
                      key={index}
                      onClick={() => {
                        handleOptionClick(option);
                        onChange(option);
                      }}
                      className="cursor-pointer text-sm font-normal text-[#3a3a3a] text-ellipsis line-clamp-1 w-4/5"
                    >
                      {option}
                    </li>
                    <hr className="my-2 last:hidden" />
                  </>
                ))}
              </ul>
            </div>
          ) : (
            <div className="relative inline-block w-full cursor-pointer bg-white rounded-lg">
              <p
                onClick={toggleDropdown}
                className="w-full bg-white text-[#999999] px-6 py-4 rounded-lg focus:outline-none flex justify-between items-center"
              >
                <span className="text-ellipsis line-clamp-1 w-4/5">
                  {selectedOption || placeholder}
                </span>
                <svg
                  className={`fill-[#999999] h-4 w-4 transform ${
                    isOpen ? "rotate-180" : "rotate-0"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 011.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                </svg>
              </p>
              {isOpen && (
                <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded-lg p-5">
                  {options.map((option, index) => (
                    <>
                      <li
                        key={index}
                        onClick={() => {
                          handleOptionClick(option);
                          onChange(option);
                        }}
                        className="cursor-pointer text-sm font-normal text-[#3a3a3a] text-ellipsis line-clamp-1 text-nowrap block"
                      >
                        {option}
                      </li>
                      <hr className="my-2 last:hidden" />
                    </>
                  ))}
                </ul>
              )}
            </div>
          )}
        </>
      )}
    />
  );
};

export default Dropdown;
